import React, { useContext } from 'react';
import { useTranslate } from 'react-redux-multilingual';
import { IsAuthContext } from 'app/App';

const ModalSelectArticlePrice = ({ show, article, selectedPriceId, onSelectPrice, onConfirm, onCancel, loading }) => {
    const t = useTranslate();
    const { authParam } = useContext(IsAuthContext);

    if (!show) return null;

    const prixSupp = (authParam.company.advanceparams.hasOwnProperty('prix_supplementaire') && authParam.company.advanceparams.prix_supplementaire.length > 0)
        ? authParam.company.advanceparams.prix_supplementaire
        : [];

    const articlePrices = article?.article_price || [];

    // Catégories B2C uniquement, avec le record article_price correspondant (même nom)
    const priceOptions = prixSupp.map((value, index) => {
        const numero = index + 1;
        if (value['destination_' + numero] !== 'b2c') return null;
        const designation = value['designation_' + numero];
        const match = articlePrices.find(p => p.name === designation);
        return match ? { id: match.id, name: designation, value: match.value, ttc: match.ttc } : null;
    }).filter(Boolean);

    return (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{t('selectArticlePrice')}</h5>
                        <button type="button" className="btn-close" onClick={onCancel} disabled={loading}></button>
                    </div>
                    <div className="modal-body">
                        <div className="form-check mb-2">
                            <input
                                className="form-check-input"
                                type="radio"
                                id="price-none"
                                name="articlePrice"
                                checked={selectedPriceId === null}
                                onChange={() => onSelectPrice(null)}
                            />
                            <label className="form-check-label" htmlFor="price-none">
                                {t('noPricingCat')}
                            </label>
                        </div>
                        {priceOptions.map(price => (
                            <div key={price.id} className="form-check mb-2">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id={`price-${price.id}`}
                                    name="articlePrice"
                                    checked={selectedPriceId === price.id}
                                    onChange={() => onSelectPrice(price.id)}
                                />
                                <label className="form-check-label" htmlFor={`price-${price.id}`}>
                                    {price.name}&nbsp;—&nbsp;{price.value}&nbsp;{price.ttc ? 'TTC' : 'HT'}
                                </label>
                            </div>
                        ))}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={loading}>
                            {t('btnCancel')}
                        </button>
                        <button type="button" className="btn btn-primary" onClick={onConfirm} disabled={loading}>
                            {loading
                                ? <span className="spinner-border spinner-border-sm"></span>
                                : t('btnValidate')
                            }
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalSelectArticlePrice;
